import axios, { AxiosResponse } from 'axios';
import Cookies from 'universal-cookie';

import { CookiesKeys } from 'enums/cookies-keys.enum';
import {
  ICumulativeLoginStreakResponse,
  ICumulativeLoginClaimResponse,
  ICumulativeLoginBand,
} from 'models/vip/i-cumulative-login.interface';

export const getCumulativeLoginStreak = (
  signal: AbortSignal
): Promise<AxiosResponse<ICumulativeLoginStreakResponse>> => {
  return axios.get(`/api/v1/cumulative-login/streak/`, {
    signal,
    headers: {
      'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
    },
  });
};

/**
 * Daily claim — grants "today's" reward for whichever streak-day band the user is in.
 * There is no reward id anymore (previously the id was in the URL); the backend resolves it.
 */
export const claimCumulativeLoginReward = (
  signal: AbortSignal
): Promise<AxiosResponse<ICumulativeLoginClaimResponse>> => {
  return axios.post(
    `/api/v1/cumulative-login/claim/`,
    {},
    {
      signal,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
      },
    }
  );
};

export const recordCumulativeLoginPresence = (signal: AbortSignal): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/api/v1/cumulative-login/presence/`,
    {},
    {
      signal,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': new Cookies().get(CookiesKeys.csrftoken),
      },
    }
  );
};

/**
 * The streak reward ladder. Public: an unauthenticated visitor gets the non-VIP bands,
 * and the backend already scopes the list to the caller's audience.
 */
export const getCumulativeLoginBands = (
  signal: AbortSignal
): Promise<AxiosResponse<ICumulativeLoginBand[]>> => {
  return axios.get(`/api/v1/cumulative-login/bands/`, { signal });
};
